import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { api } from '../lib/api';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [analystEmails, setAnalystEmails] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  // Fetch analyst roster once we have a user. Public GET, safe for any role.
  useEffect(() => {
    if (!user) return;
    api.get('/analysts').then(res => {
      const emails = res.data.emails || [];
      setAnalystEmails(emails);
      try { localStorage.setItem('wolf_analyst_emails', JSON.stringify(emails)); } catch (e) { /* noop */ }
    }).catch(() => setAnalystEmails([]));
  }, [user]);

  const signOut = async () => {
    await supabase.auth.signOut();
    navigate('/login');
  };

  // Explicit user_metadata.role wins. Otherwise: analyst roster > default admin.
  const metaRole = user?.user_metadata?.role;
  const emailLower = (user?.email || '').toLowerCase();
  let role = metaRole || 'admin';
  if (!metaRole && analystEmails.includes(emailLower)) role = 'analyst';
  const isViewer = role === 'viewer';
  const isAdmin = role === 'admin';
  const isAnalyst = role === 'analyst';

  return { user, loading, signOut, role, isViewer, isAdmin, isAnalyst };
};
